import React, { useEffect, useState } from 'react';
import VideoHero from '../components/VideoHero';
import Gallery from '../components/Gallery';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import GoogleReviews from '../components/GoogleReviews';
import FAQ from '../components/FAQ';

const HomePage = () => {
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    setIsLeaving(false);
    
    return () => {
      // Mark as leaving to stop all animations
      setIsLeaving(true);
      
      // Give animations time to stop before unmounting
      setTimeout(() => {
        const motionElements = document.querySelectorAll('[style*="transform"]');
        motionElements.forEach(el => {
          if (el.style) {
            el.style.transform = '';
          }
        });
      }, 50);
    };
  }, []);

  return (
    <div style={{ opacity: isLeaving ? 0 : 1, transition: 'opacity 0.1s' }}>
      <VideoHero />
      <Gallery />
      <Hero />
      <Services />
      <About />
      <FAQ />
      <GoogleReviews />
    </div>
  );
};

export default HomePage;
